import {createSvgIcon} from "@mui/material";

const CloseIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M6 6L14 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M14 6L6 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>,
  'Close'
)

export default CloseIcon
